"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeRangePicker = void 0;
var react_1 = __importStar(require("react"));
var BlockLabel_1 = require("../../v2/components/BlockLabel");
var getBlockLabelProps_1 = require("../../utils/getBlockLabelProps");
var TimePicker_1 = require("../TimePicker");
var TimeRangePicker = function (props) {
    var value = props.value, onChange = props.onChange, id = props.id, readOnly = props.readOnly, invert = props.invert, disabled = props.disabled;
    var _a = (0, react_1.useState)(value || [null, null]), _value = _a[0], _setValue = _a[1];
    var handleOnchange = function (i, v) {
        var newValue = value ? __spreadArray([], value, true) : [];
        newValue[i] = v;
        onChange && onChange(id, newValue);
    };
    (0, react_1.useEffect)(function () {
        if (value) {
            _setValue(value);
        }
    }, [value]);
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(BlockLabel_1.BlockLabel, __assign({}, (0, getBlockLabelProps_1.getBlockLabelProps)(props))),
        react_1.default.createElement("div", { style: { display: "flex", columnGap: '2rem', flexWrap: 'wrap', rowGap: '1rem' } },
            react_1.default.createElement(TimePicker_1.TimePicker, { value: _value && _value[0], id: 0, onChange: handleOnchange, readOnly: readOnly, invert: invert, disabled: disabled }),
            react_1.default.createElement(TimePicker_1.TimePicker, { value: _value && _value[1], id: 1, onChange: handleOnchange, readOnly: readOnly, invert: invert, disabled: disabled }))));
};
exports.TimeRangePicker = TimeRangePicker;
